import { render } from "./FurnitureForm.vue?vue&type=template&id=197e43ea&scoped=true"
import script from "./FurnitureForm.vue?vue&type=script&lang=js"
export * from "./FurnitureForm.vue?vue&type=script&lang=js"

import "./FurnitureForm.vue?vue&type=style&index=0&id=197e43ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197e43ea"]])

export default __exports__